import 'focus-visible/dist/focus-visible';
import { html, LitElement } from 'lit-element';
import { styles } from './uc-button.styles';

export const props = {
  buttonstyle: { type: String },
  buttonsize: { type: String, reflect: true },
  scalable: { type: Boolean, reflect: true },
};

/**
 * Base button component
 *
 * @attr {base|primary|secondary|text} buttonstyle default button style
 * @attr {m|l|fullwidth|container} buttonsize - size of button
 */
export class UcButton extends LitElement {
  static get properties() {
    return props;
  }

  static get styles() {
    return styles;
  }

  constructor() {
    super();

    this.buttonstyle = 'base';
    this.buttonsize = '';
    this.scalable = false;
  }

  firstUpdated() {
    if (window.applyFocusVisiblePolyfill != null) {
      window.applyFocusVisiblePolyfill(this.shadowRoot);
    }
  }

  render() {
    return html`
      ${this.scalable
        ? html`
            <div class="button-scalable-bg"></div>
          `
        : ''}
      <slot class="button ${this.buttonstyle} ${this.buttonsize}"></slot>
    `;
  }
}
